import React from 'react';
import useWithStore from "@/Hooks/useWithStore";
import BaseLayout from "@/Layouts/BaseLayout";
import {Breadcrumbs} from '@mui/material';
import JobsItem from "@/Pages/Jobs/JobsItem";
import JobsForm from "@/Pages/Jobs/JobsForm";
import Link from "@/Layouts/Link";
import Svg from "@/Components/Svg";
import '@/Pages/Jobs/scss/index.scss';

class Jobs extends React.Component {
    render() {
        const {modalStore = {}} = this.props.stores;

        return <BaseLayout {...this.props}>
            <section className={`section`}>
                <div className={`breadcrumbs`}>
                    <div className={`container`}>
                        <Breadcrumbs maxItems={2} itemsAfterCollapse={2}>
                            <Link className={`breadcrumbs__link`} href={`/`}>
                                Главная
                            </Link>
                            <p className={`breadcrumbs__text`}>
                                Вакансии
                            </p>
                        </Breadcrumbs>
                    </div>
                </div>
                <div className={`container`}>
                    <h1 className={`h1`}>Вакансии</h1>
                    <div id={`jobs`} className={`jobs`}>
                        <div className={`jobs__elements`}>
                            <JobsItem {...this.props} />
                        </div>
                        <div className={`jobs__forms`}>
                            <div className={`jobs__send-resume`}>
                                <div className={`jobs__icon-mail`}>
                                    <Svg id={`sendEmail`} className={`svg__sendEmail`} />
                                </div>
                                <p className={`jobs__subtitle`}>
                                    Не нашли подходящей вакансии, но хотите стать частью команды?
                                </p>
                                <p className={`jobs__description`}>
                                    Отправьте свое резюме
                                </p>
                                <div className={`btn btn__white btn__send-resume`}
                                     onClick={() => modalStore.openModalJobsForm('')}>
                                    отправить резюме
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <JobsForm {...this.props} />
        </BaseLayout>
    }
}

export default useWithStore(Jobs);



